import React, { useState, useEffect } from 'react';
import wrapStore from '@src/utils/wrap-store';
import ArticleStore from './store';
import Link from '@src/components/link';
import cx from 'classnames';
import xauCss from '@src/components/xfe-animation-css';

const styles = require('./index.less');

const Article4 = ({ store }) => {
  store.use();
  const [activeAnchor, setActiveAnchor] = useState('');
  const [showSidebar, setShowSidebar] = useState(false);

  const scrollToAnchor = anchorId => {
    const element = document.getElementById(anchorId);
    if (element) {
      const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
      const offset = 50; // 向上的偏移值
      window.scrollTo({ top: elementTop - offset, behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const anchors = ['百万金币', '鸿运免单', '签到豪礼', '预创角色', '关注领码', '送黄金套', '加速成长', '十大风云', '多重好礼', '虎虎生威'];
    const handleScroll = () => {
      let currentActive = '';
      for (const id of anchors) {
        const element = document.getElementById(id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200) {
            currentActive = id;
          }
        }
      }
      setActiveAnchor(currentActive);

      const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
      const threshold = (960 / 192) * rootFontSize;
      setShowSidebar(window.scrollY >= threshold);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.article}>
      <div className="xfe-root-article">
        <div className={cx('xfe-layer-3', { ...xauCss.FADE.IN_UP() })} />
        <div className={cx('xfe-group-1', { ...xauCss.FADE.IN_UP() })} data-name="顶部导航条">
          <div className="xfe-layer-4" />
          <Link className="xfe-layer-5" data-id={'百万金币'} onClick={() => scrollToAnchor('百万金币')} />
          <Link className="xfe-layer-6" data-id={'鸿运免单'} onClick={() => scrollToAnchor('鸿运免单')} />
          <Link className="xfe-layer-7" data-id={'签到豪礼'} onClick={() => scrollToAnchor('签到豪礼')} />
          <Link className="xfe-layer-8" data-id={'预创角色'} onClick={() => scrollToAnchor('预创角色')} />
          <Link className="xfe-layer-9" data-id={'关注领码'} onClick={() => scrollToAnchor('关注领码')} />
          <Link className="xfe-layer-10" data-id={'送黄金套'} onClick={() => scrollToAnchor('送黄金套')} />
          <Link className="xfe-layer-11" data-id={'加速成长'} onClick={() => scrollToAnchor('加速成长')} />
          <Link className="xfe-layer-12" data-id={'十大风云'} onClick={() => scrollToAnchor('十大风云')} />
          <Link className="xfe-layer-13" data-id={'多重好礼'} onClick={() => scrollToAnchor('多重好礼')} />
          <Link className="xfe-layer-14" data-id={'虎虎生威'} onClick={() => scrollToAnchor('虎虎生威')} />
        </div>

        <div className={cx('xfe-group-2', { visible: showSidebar })} data-name="侧栏导航">
          <div className="xfe-layer-15" />
          <div className="xfe-group-3" data-name="组 35">
            <Link className={cx('xfe-group-4', { active: activeAnchor === '百万金币' })} data-name="百万金币" onClick={() => scrollToAnchor('百万金币')}>
              <div className="xfe-layer-16" />
              <div className="xfe-layer-17" />
            </Link>

            <Link className={cx('xfe-group-5', { active: activeAnchor === '鸿运免单' })} data-name="鸿运免单" onClick={() => scrollToAnchor('鸿运免单')}>
              <div className="xfe-layer-18" />
              <div className="xfe-layer-19" />
            </Link>

            <Link className={cx('xfe-group-6', { active: activeAnchor === '签到豪礼' })} data-name="签到豪礼" onClick={() => scrollToAnchor('签到豪礼')}>
              <div className="xfe-layer-20" />
              <div className="xfe-layer-21" />
            </Link>

            <Link className={cx('xfe-group-7', { active: activeAnchor === '预创角色' })} data-name="预创角色" onClick={() => scrollToAnchor('预创角色')}>
              <div className="xfe-layer-22" />
              <div className="xfe-layer-23" />
            </Link>

            <Link className={cx('xfe-group-8', { active: activeAnchor === '关注领码' })} data-name="关注领码" onClick={() => scrollToAnchor('关注领码')}>
              <div className="xfe-layer-24" />
              <div className="xfe-layer-25" />
            </Link>

            <Link className={cx('xfe-group-9', { active: activeAnchor === '送黄金套' })} data-name="送黄金套" onClick={() => scrollToAnchor('送黄金套')}>
              <div className="xfe-layer-26" />
              <div className="xfe-layer-27" />
            </Link>

            <Link className={cx('xfe-group-10', { active: activeAnchor === '加速成长' })} data-name="加速成长" onClick={() => scrollToAnchor('加速成长')}>
              <div className="xfe-layer-28" />
              <div className="xfe-layer-29" />
            </Link>

            <Link className={cx('xfe-group-11', { active: activeAnchor === '十大风云' })} data-name="十大风云" onClick={() => scrollToAnchor('十大风云')}>
              <div className="xfe-layer-30" />
              <div className="xfe-layer-31" />
            </Link>

            <Link className={cx('xfe-group-12', { active: activeAnchor === '多重好礼' })} data-name="多重好礼" onClick={() => scrollToAnchor('多重好礼')}>
              <div className="xfe-layer-32" />
              <div className="xfe-layer-33" />
            </Link>

            <Link className={cx('xfe-group-13', { active: activeAnchor === '虎虎生威' })} data-name="虎虎生威" onClick={() => scrollToAnchor('虎虎生威')}>
              <div className="xfe-layer-34" />
              <div className="xfe-layer-35" />
            </Link>

            <Link className="xfe-group-14" data-name="返回顶部" onClick={scrollToTop}>
              <div className="xfe-layer-36" />
              <div className="xfe-layer-37" />
            </Link>
          </div>
        </div>
        <div className={cx('xfe-group-content', { ...xauCss.FADE.IN_DOWN() })} data-name="内容区" dangerouslySetInnerHTML={{ __html: store.content }} />
      </div>
    </div>
  );
};

export default wrapStore(Article4, ArticleStore);
